module.exports = __webpack_public_path__ + "img/It-studio.e09c91b9.gif";